export default "__VITE_ASSET__CrNWoU7M__"